export default __webpack_public_path__ + "static/media/main_bg_pentagon2.07fb2f66.svg";